/**
 * WhatsNewButton - Footer button to manually open What's New panel
 */

import React from "react";
import { Button } from "primereact/button";
import PropTypes from "prop-types";

const WhatsNewButton = ({ version, hasUnread, onClick }) => {
  return (
    <Button
      label={`Novidades v${version}`}
      icon="pi pi-megaphone"
      className="p-button-text p-button-sm whats-new-footer-btn"
      onClick={onClick}
      tooltip="Ver novidades desta versão"
      tooltipOptions={{ position: "top" }}
      data-evo-id="footer-btn-whats-new"
    >
      {hasUnread && (
        <span className="whats-new-badge" aria-label="Não lido">
          ●
        </span>
      )}
    </Button>
  );
};

WhatsNewButton.propTypes = {
  version: PropTypes.string.isRequired,
  hasUnread: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

WhatsNewButton.defaultProps = {
  hasUnread: false,
};

export default WhatsNewButton;
